export default {
  heading: 'Comfortaa, sans-serif',
  subheading: 'Noto Sans Display',
  body: 'Comfortaa, sans-serif',
  body2: 'Noto Sans, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Comfortaa, cursive',
  googleFonts: ['Noto Sans Display:300,400,600,800', 'Comfortaa']
}
